import PropTypes from "prop-types";

export const MapVendorModel = {
    id: PropTypes.number,
    lat: PropTypes.number,
    lng: PropTypes.number,
    locationId: PropTypes.number,
    displayName: PropTypes.string,
    addressInfo: PropTypes.string,
    marker: PropTypes.object
};

export const FilterModel = {
    id: PropTypes.number,
    name: PropTypes.string,
    icon: PropTypes.string,
    isSelected: PropTypes.bool
};

export const VendorFilterModel = {
    inherentRiskFilterOptions: PropTypes.arrayOf(PropTypes.shape(FilterModel)),
    residualRiskFilterOptions: PropTypes.arrayOf(PropTypes.shape(FilterModel)),
    functionFilterOptions: PropTypes.arrayOf(PropTypes.shape(FilterModel)),
    eventFilterOptions: PropTypes.arrayOf(PropTypes.shape(FilterModel))
};
